import { useMemo } from "react";

// porp-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-chartjs-2 components
import { Bar, Line } from "react-chartjs-2";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import moment from "moment";

// ReportsBarChart configurations
import configs from "examples/Charts/BarCharts/ReportsBarChart/configs";

const graphData = (gr, flag) => {
  // if (flag) {
  //   console.log("fine");

  // }
  return (
    gr?.map((row) =>
      row?.subscribers_count > 0 ? row?.subscribers_count / row?.user_count : 0
    ) || []
  );
};
const calculateAv = (g) => {
  let data = graphData(g);
  if (data?.length) {
    return data?.reduce((a, b) => a + b) / data.length;
  }
};

function ReportsBarChart({
  color,
  title,
  description,
  date,
  chart,
  graph,
  dgraph,
  flag,
  totalFlag,
}) {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );
  const { options } = configs(chart || [], chart || {});
  // const options = "";
  // function to change number into month

  const ddata = {
    labels: dgraph?.map((row) => moment(row.date).format("DD/MM")),
    datasets: [
      {
        label: "Conversions/Day",
        data:
          dgraph?.map((row) =>
            row?.subscribers_count > 0
              ? row?.subscribers_count / row?.user_count
              : 0
          ) || [],
        backgroundColor: "#ffff",
        borderColor: "rgba(255, 255, 255,0.5)",
      },
    ],
  };
  const data = {
    labels: graph?.map((row) => moment(row._id).format("MMM")),
    datasets: [
      {
        label: "Conversions/Month",
        data:
          graph?.map((row) =>
            row?.total_subscribers > 0
              ? row?.total_subscribers / row?.total_users
              : 0
          ) || [],
        backgroundColor: "#ffff",
        borderColor: "rgba(255, 255, 255,0.5)",
      },
    ],
  };

  const mdata = {
    labels: graph?.map((row) => moment(row.date).format("DD")),
    datasets: [
      {
        label: "Conversions/Day",
        data:
          graph?.map((row) =>
            row?.subscribers_count > 0
              ? row?.subscribers_count / row?.user_count
              : 0
          ) || [],
        backgroundColor: "#ffff",
        borderColor: "rgba(255, 255, 255,0.5)",
      },
    ],
  };

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox padding="1rem">
        {useMemo(
          () => (
            <MDBox
              variant="gradient"
              bgColor={color}
              borderRadius="lg"
              coloredShadow={color}
              py={2}
              pr={0.5}
              height="20.5rem"
            >
              {totalFlag ? (
                flag ? (
                  <Bar data={data} options={options} />
                ) : (
                  <Bar data={mdata} options={options} />
                )
              ) : (
                <Bar data={ddata} options={options} />
              )}
            </MDBox>
          ),
          [chart, color]
        )}
        <MDBox pt={3} pb={1} px={1}>
          <MDTypography variant="h6" textTransform="capitalize">
            Conversion Graph
          </MDTypography>
          <MDTypography
            component="div"
            variant="button"
            color="text"
            fontWeight="light"
          >
            Conversion Rate :{calculateAv(graph)?.toFixed(4)}% in last{" "}
            {graphData(graph).length} Days
          </MDTypography>
          <Divider />
        </MDBox>
      </MDBox>
    </Card>
  );
}

// Setting default values for the props of ReportsBarChart
ReportsBarChart.defaultProps = {
  color: "dark",
  description: "",
};

// Typechecking props for the ReportsBarChart
ReportsBarChart.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  date: PropTypes.string.isRequired,
  chart: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.array, PropTypes.object])
  ).isRequired,
};

export default ReportsBarChart;
